import { z } from 'zod';
import { adresseSchema, centimesPositifsSchema, idSchema, tauxPointsDeBaseSchema, } from '../model/commun.js';
export const ETATS_CONTRAT_LOCATION = [
    'brouillon',
    'actif',
    'suspendu',
    'termine',
    'rompu',
];
export const etatContratLocationSchema = z.enum(ETATS_CONTRAT_LOCATION);
export const jourLocationSchema = z.iso.date('Date civile attendue : AAAA-MM-JJ.');
export const jourFacturationLocationSchema = z.int().min(1).max(28);
export const periodeLocationSchema = z
    .strictObject({ debut: jourLocationSchema, fin: jourLocationSchema })
    .refine((periode) => periode.fin > periode.debut, 'La période doit avoir une durée positive.');
export const suspensionLocationSchema = z
    .strictObject({ du: jourLocationSchema, au: jourLocationSchema.nullable() })
    .refine((suspension) => suspension.au === null || suspension.au > suspension.du, 'La suspension doit finir après son début.');
export const optionAchatLocationSchema = z.strictObject({
    prixConvenuCentimes: centimesPositifsSchema,
    pourcentagePointsDeBase: tauxPointsDeBaseSchema,
    plafondCentimes: centimesPositifsSchema,
    valableJusquAu: jourLocationSchema,
});
export const ligneLocationCreationSchema = z.strictObject({
    oeuvreId: idSchema,
    exemplaireId: idSchema.nullable().default(null),
    loyerMensuelHtCentimes: centimesPositifsSchema,
    valeurReferenceCentimes: centimesPositifsSchema.optional(),
    optionAchat: optionAchatLocationSchema.nullable().default(null),
});
export const contratLocationCreationSchema = z.strictObject({
    locataireId: idSchema,
    adresseInstallation: adresseSchema,
    debutLe: jourLocationSchema,
    dureeMois: z.int().positive().nullable(),
    preavisMois: z.int().min(0),
    jourFacturation: jourFacturationLocationSchema,
    depotGarantieCentimes: centimesPositifsSchema.default(0),
    assurance: z.strictObject({
        charge: z.enum(['locataire', 'galerie']),
        assureur: z.string().trim().optional(),
        police: z.string().trim().optional(),
    }),
    conditionsRotation: z.strictObject({
        periodiciteMois: z.int().positive().nullable(),
        texte: z.string().trim(),
    }),
    lignes: z.array(ligneLocationCreationSchema).min(1),
    optionAchat: optionAchatLocationSchema.nullable().default(null),
    notes: z.string().trim().max(4000).default(''),
});
export const ligneLocationCalculSchema = z
    .object({
    titre: z.string().min(1),
    loyerMensuelHtCentimes: centimesPositifsSchema,
    debutLe: jourLocationSchema,
    finLe: jourLocationSchema.nullable(),
})
    .refine((ligne) => ligne.finLe === null || ligne.finLe >= ligne.debutLe, 'La ligne ne peut pas finir avant son début.');
export const contratLocationCalculSchema = z
    .object({
    etat: etatContratLocationSchema,
    debutLe: jourLocationSchema,
    finLe: jourLocationSchema.nullable(),
    jourFacturation: jourFacturationLocationSchema,
    lignes: z.array(ligneLocationCalculSchema),
    suspensions: z.array(suspensionLocationSchema),
})
    .refine((contrat) => contrat.finLe === null || contrat.finLe >= contrat.debutLe, 'Le contrat ne peut pas finir avant son début.');
export const prorataLocationSchema = z
    .strictObject({
    loyerMensuelHtCentimes: centimesPositifsSchema,
    debutLigne: jourLocationSchema,
    finLigne: jourLocationSchema.nullable(),
    periode: periodeLocationSchema,
    suspensions: z.array(suspensionLocationSchema),
})
    .refine((ligne) => ligne.finLigne === null || ligne.finLigne >= ligne.debutLigne, 'La ligne ne peut pas finir avant son début.');
export const factureImputationLocationSchema = z
    .strictObject({
    totalHtCentimes: centimesPositifsSchema,
    totalTtcCentimes: centimesPositifsSchema,
    regleCentimes: centimesPositifsSchema,
    avoireCentimes: centimesPositifsSchema,
    htConcerneCentimes: centimesPositifsSchema,
})
    .refine((facture) => facture.htConcerneCentimes <= facture.totalHtCentimes &&
    facture.totalHtCentimes <= facture.totalTtcCentimes &&
    facture.avoireCentimes <= facture.totalTtcCentimes, 'Les montants concernés et l’avoir doivent rester dans les totaux de la facture.');
export const imputationLocationSchema = z.strictObject({
    prixConvenuCentimes: centimesPositifsSchema,
    pourcentagePointsDeBase: tauxPointsDeBaseSchema,
    plafondCentimes: centimesPositifsSchema,
    factures: z.array(factureImputationLocationSchema),
});
//# sourceMappingURL=schemas.js.map